<template>
  <div class="flex items-center">
    <button
      ref="icon-button"
      class="rounded-sm hover:bg-slate-200"
      @click.prevent="openMenu"
    >
      <slot name="icon" />
    </button>
    <div
      v-if="isOpen"
      ref="menu"
      class="menu"
    >
      <slot name="menu-items" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconMenu',
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        document.addEventListener('click', this.closeMenu)
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeMenu)
  },
  methods: {
    openMenu() {
      this.isOpen = !this.isOpen
    },
    closeMenu(event) {
      if (this.isOpen && !this.$refs['icon-button'].contains(event.target)) {
        this.isOpen = false
      }
    },
  },
}
</script>

<style scoped>
.menu {
  position: absolute;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 4px;
}
</style>
